// import { Col } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useStore from 'src/hooks/useStore';
import { IUserStore } from 'src/store/user';
import styles from './menu-item.module.less';

export interface IMenuItem {
	menuId: string;
	title: string;
	isActive: boolean;
	onItemClick(menuId: string): void;
	icon?: React.ReactNode;
	linkMenuList: string[];
}
const MenuItem: FC<IMenuItem> = ({ menuId, title, isActive, onItemClick, icon, linkMenuList }: IMenuItem) => {
	const [activeClass, setActiveClass] = useState('');

	const userStore: IUserStore = useStore('userStore');
	const { pathname } = useLocation();

	// const activeClass = isActive || pathname == menuId ? styles.activeClass : '';

	const onItemClickInternal = () => {
		if (isActive) {
			return;
		}
		onItemClick(menuId);
	};
	useEffect(() => {
		if (linkMenuList.includes(pathname) && pathname == menuId) {
			userStore.linkMenuPrev = menuId;
			setActiveClass(styles.activeClass);
		} else if (!linkMenuList.includes(pathname) && userStore.linkMenuPrev == menuId) {
			setActiveClass(styles.activeClass);
		} else {
			setActiveClass('');
		}
	}, [pathname]);
	return (
		<>
			<div
				key={`menu_item_${menuId}`}
				onClick={onItemClickInternal}
				className={`${styles.menuItemContainer} ${activeClass}`}>
				{icon && <div>{icon}</div>}
				<div>{title}</div>
			</div>
		</>
	);
};

export default MenuItem;
